import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as I } from "../../../../../external/preact/compat/dist/compat.module.js";
import { createContext as N, Fragment as h } from "../../../../../external/preact/dist/preact.module.js";
import { useMemo as o, useCallback as R, useEffect as w, useContext as O } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import j from "../../../../../core/Context/useCoreContext.js";
import { ButtonVariant as y } from "../../../../internal/Button/types.js";
import { ActiveView as B } from "../types.js";
import { Icon as A } from "../../../../internal/Icon/Icon.js";
import { EMPTY_ARRAY as _, EMPTY_OBJECT as E } from "../../../../../utils/value/constants.js";
import { noop as D } from "../../../../../utils/common.js";
const M = N({
  availableItems: _,
  primaryAction: D,
  secondaryAction: D,
  transaction: E,
  extraFields: E
}), Q = I(
  ({
    children: P,
    lineItems: Y,
    refundAvailable: n,
    refundDisabled: f,
    setActiveView: l,
    setPrimaryAction: u,
    setSecondaryAction: p,
    transaction: i,
    transactionNavigator: k,
    extraFields: F
  }) => {
    const { i18n: r } = j(), { currentTransaction: v, canNavigateBackward: T, canNavigateForward: g, backward: x, forward: C } = k, b = o(() => ({ title: r.get("refundAction") }), [r]), a = o(() => !n || f, [n, f]), s = R(
      () => void (!a && l(B.REFUND)),
      [a, l]
    ), t = o(() => {
      if (v === i.id) {
        if (T) return 2;
        if (g) return 1;
      }
    }, [T, g, v, i]), c = R(() => {
      switch (t) {
        case 2:
          return void x();
        case 1:
          return void C();
      }
    }, [t, x, C]), d = o(() => {
      switch (t) {
        case 2:
          return {
            title: r.get("refund.returnToRefund"),
            renderTitle: (m) => /* @__PURE__ */ e(h, { children: [
              /* @__PURE__ */ e(A, { style: { transform: "scaleX(-1)" }, name: "angle-right" }),
              /* @__PURE__ */ e("span", { children: m })
            ] })
          };
        case 1:
          return {
            title: r.get("refund.goToPayment"),
            renderTitle: (m) => /* @__PURE__ */ e(h, { children: [
              /* @__PURE__ */ e(A, { name: "angle-right" }),
              /* @__PURE__ */ e("span", { children: m })
            ] })
          };
      }
    }, [t, r]);
    return w(() => {
      u(
        n ? Object.freeze({
          disabled: a,
          event: s,
          variant: y.PRIMARY,
          ...b
        }) : void 0
      );
    }, [s, n, a, b, u]), w(() => {
      p(
        t && d ? Object.freeze({
          disabled: !1,
          event: c,
          variant: y.SECONDARY,
          ...d
        }) : void 0
      );
    }, [t, c, d, p]), /* @__PURE__ */ e(M.Provider, { value: { availableItems: Y, primaryAction: s, secondaryAction: c, transaction: i, extraFields: F }, children: P });
  }
), S = () => O(M);
export {
  Q as TransactionDetailsProvider,
  S as default,
  S as useTransactionDetailsContext
};
